import { useEffect, useState } from 'react';

/**
 * Generate a key that changes on a given interval. This is used to force a
 * re-render of a component, primarily to prevent users from manually editing
 * the DOM.
 */
export default function useKeyWithInterval(interval: number = 1000) {
  const [key, setKey] = useState(0);

  useEffect(() => {
    const t = window.setInterval(() => {
      setKey(Date.now());
    }, interval);

    return () => {
      clearInterval(t);
    };
  }, [interval]);

  return key;
}
